import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// rem配置文件
import './utils/rem'
// 自动注册全局组件
import './requireComponent'
// import '@/assets/style/achievement.scss' // global css
import '@/assets/style/ruoyi.scss' // ruoyi css
// 自动导入element组件
import element from './utils/auto-import'
import '@/assets/style/element-variables.scss'
// 工具类库
import Lodash from 'lodash'
// 字典标签组件
import DictTag from '@/components/DictTag'
// 全局工具函数
import {getToken, delay, debounce, isValidPhoneNumber,switchArray,filterArea} from '@/utils'
// 字典数据组件
import DictData from '@/components/DictData/index'
import AchievementDictData from '@/components/DictData/achievementDict'
import {parseTime} from '@/utils/ruoyi'
import PublicDetails from './views/supermarket/components/public-details/index.vue'
import BackNavbar from '@/views/supermarket/components/back-navbar/index.vue'


import { Descriptions, DescriptionsItem } from 'element-ui'
import 'element-ui/lib/theme-chalk/descriptions.css'
import 'element-ui/lib/theme-chalk/descriptions-item.css'

Vue.use(Descriptions)
Vue.use(DescriptionsItem)
DictData.install()
AchievementDictData.install()
Vue.component('DictTag', DictTag)
Vue.component('PublicDetails', PublicDetails)
Vue.component('BackNavbar', BackNavbar)
Vue.prototype.filterArea = filterArea
Vue.prototype.$lodash = Lodash
Vue.prototype.$getToken = getToken
Vue.prototype.$delay = delay
Vue.prototype.$debounce = debounce
Vue.prototype.switchArray = switchArray
Vue.prototype.$isValidPhoneNumber = isValidPhoneNumber
Vue.directive('lazy', {
    inserted: (el, binding) => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersectionRatio > 0 || entry.isIntersecting) {
                        el.src = binding.value;
                        observer.unobserve(el);
                    }
                });
            },
            {
                rootMargin: '200px 0px', // 提前200px加载
                threshold: 0.01 // 只要1%可见就触发
            }
        );
        observer.observe(el);
    }
});
Vue.config.productionTip = false
Vue.prototype.parseTime = parseTime
Vue.use(element)

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
}).$mount('#app')
